import Vue from "vue"
import axios from "axios"
import VueAxios from "vue-axios"

const ApiService = {
  init() {
    Vue.use(VueAxios, axios)

    if (process.env.NODE_ENV === 'development') {
      Vue.axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT
    } else {
      Vue.axios.defaults.baseURL = window.location.origin + process.env.VUE_APP_ROOT + '/data'
    }
  },

  query(resource, params) {
    return Vue.axios.get(resource, params).catch(error => {
      throw new Error(`[RWV] ApiService ${error}`)
    })
  },

  get(resource, slug) {
    return Vue.axios.get(`${resource}/${slug}`).catch(error => {
      throw new Error(`[RWV] ApiService ${error}`)
    })
  },

  post(resource, params) {
    return Vue.axios.post(`${resource}`, params)
  },

  update(resource, slug, params) {
    return Vue.axios.put(`${resource}/${slug}`, params)
  },

  put(resource, params) {
    return Vue.axios.put(`${resource}`, params)
  },

  delete(resource) {
    return Vue.axios.delete(resource).catch(error => {
      throw new Error(`[RWV] ApiService ${error}`)
    })
  }
}

export default ApiService

export const ArticlesService = {
  get(locale) {
    let param = (locale == '') ? '' : '?locale=' + locale
    return ApiService.get("/articles", param)
  },
}
export const MessagesService = {
  get(lg2, locale) {
    const langParam = '?lang=' + lg2
    const localeParam = (locale == '') ? '' : '&locale=' + locale
    return ApiService.get("/messages", langParam + localeParam)
  },
}

export const LangService = {
  get(locale) {
    let param = (locale == '') ? '' : '?locale=' + locale
    return ApiService.get("/languages", param)
  },
}

export const CategoriesService = {
  get() {
    return ApiService.get('/categories', '')
  }
}

export const CreateplusTemplatesService = {
  get(locale) {
    let param = (locale == '') ? '' : '?locale=' + locale
    return ApiService.get("/createplus_templates", param)
  },
}

export const CreateplusMessagesService = {
  get(lg2, locale) {
    const langParam = '?lang=' + lg2
    const localeParam = (locale == '') ? '' : '&locale=' + locale
    return ApiService.get("/createplus_messages", langParam + localeParam)
  },
}